<template>
    <div class="bulma-box-padding">
        <h3 class="title is-5 has-text-light">Novedades</h3>
        <p v-show="false">News, noticias y novedades del servidor de Mu, Mucrisis.</p>
        <article class="media" v-for="(nw,n) in news" :key="n">
            <figure class="media-left">
                <p class="image is-64x64">
                    <span :class="['is-size-1','mu-font','is-uppercase',`has-text-${nw.letterColor}`]">{{nw.letter}}</span>
                </p>
            </figure>
            <div class="media-content">
                <div class="content">
                <p class="has-text-justified has-text-light">
                    <strong :class="`has-text-${nw.titleColor}`">{{nw.title}}</strong>  <!-- <small>31m</small> -->
                    <br>
                    {{nw.text}}
                </p>
                </div>
                <nav class="level is-mobile">
                <div class="level-left">
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-reply"></i></span>
                    </a>
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                    </a>
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-heart"></i></span>
                    </a>
                </div>
                </nav>
            </div>
            <!-- <div class="media-right">
                <a :href="nw.link" target="_blank" class="has-text-grey"><fa icon="external-link-alt" /></a>
            </div> -->
        </article>
    </div>
</template>

<script>
export default {
    name:'HomeNews',
    computed: {
        news() {
            return this.$store.getters.GetNews.slice(0,4)
        }
    }
}
</script>

<style>

</style>